import React from 'react';

export function ProbBar({ label, pct, color, textColor }) {
    return (
        <div>
            <div className="flex justify-between mb-1">
                <span className={`tech-mono text-xs ${textColor}`}>{label}</span>
                <span className={`heading-primary text-2xl ${textColor}`}>{pct}%</span>
            </div>
            <div className="prob-bar h-3">
                <div className={`prob-bar-fill ${color}`} style={{ width: `${pct}%` }} />
            </div>
        </div>
    );
}

export function StatCard({ label, value, color = 'text-white', sub }) {
    return (
        <div className="glass-card p-3 text-center">
            <div className="tech-mono text-[9px] text-white/30">{label}</div>
            <div className={`heading-primary text-xl ${color}`}>{value}</div>
            {sub && <div className="text-[10px] text-white/20">{sub}</div>}
        </div>
    );
}

export function EngineCard({ title, pctA, pctB, teamA, teamB }) {
    return (
        <div className="glass-card p-3">
            <div className="tech-mono text-[9px] text-white/30 mb-1">{title}</div>
            <div className="flex items-center justify-between">
                <span className="text-xs text-cyan-400">{teamA}: {pctA}%</span>
                <span className="text-xs text-pink-400">{teamB}: {pctB}%</span>
            </div>
            <div className="prob-bar h-1.5 mt-1.5">
                <div className="h-full rounded-full bg-cyan-500" style={{ width: `${pctA}%` }} />
            </div>
        </div>
    );
}
